/**
 * Constants for the circular study progress ring SVG.
 * 3 color states based on target percentage with ring geometry values.
 */

import { red, orange, green } from "@/theme/colors";

/** Ring colors and i18n message keys per progress state */
export const PROGRESS_STATES = {
  completed: { active: green[500], inactive: null, message: "dashboard.weeklyLearning.achieved" },
  nearlyReach: { active: orange[500], inactive: orange[50], message: "dashboard.weeklyLearning.almostThere" },
  underTarget: { active: red[500], inactive: red[50], message: "dashboard.weeklyLearning.keepGoing" },
} as const;

/** SVG ring geometry */
export const RING_SIZE = 164;
export const RING_STROKE_WIDTH = 16;
export const RING_RADIUS = (RING_SIZE - RING_STROKE_WIDTH) / 2;
export const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;
/** Gap in degrees between active and inactive arcs */
export const RING_GAP_DEGREES = 4;
export const RING_GAP_LENGTH = (RING_GAP_DEGREES / 360) * RING_CIRCUMFERENCE;
